import React, { useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import { FiX } from "react-icons/fi";

const ImageLightbox = ({ src, alt, onClose }) => {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") onClose();
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  if (!src) return null;

  // Render at document.body via a portal so the lightbox isn't trapped inside the chat widget's
  // transformed ancestor. The chat widget panel uses CSS `transform` for its slide-in animation,
  // and any `position: fixed` descendant of a transformed element is positioned relative to that
  // ancestor instead of the viewport — which made the close button land outside the widget.
  return createPortal(
    <div className="chat-lightbox" onClick={onClose}>
      <img
        className="chat-lightbox__img"
        src={src}
        alt={alt || "Image preview"}
        onClick={(e) => e.stopPropagation()}
      />
      <button className="chat-lightbox__close" onClick={onClose} aria-label="Close">
        <FiX />
      </button>
    </div>,
    document.body
  );
};

export default ImageLightbox;
